import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-company-lookup',
  templateUrl: './micro-company-lookup.component.html'
})
export class MicroCompanyLookupComponent  {

  @Input()
  companyId:any;

  @Input()
  link:boolean = true;
}
